import { render, staticRenderFns } from "./AddOrganizationPointOfContactModal.vue?vue&type=template&id=6a2f2899&"
import script from "./AddOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2f2899')) {
      api.createRecord('6a2f2899', component.options)
    } else {
      api.reload('6a2f2899', component.options)
    }
    module.hot.accept("./AddOrganizationPointOfContactModal.vue?vue&type=template&id=6a2f2899&", function () {
      api.rerender('6a2f2899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/point-of-contact/AddOrganizationPointOfContactModal.vue"
export default component.exports